import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ComparisonObjectsWithLogicalOperators,
  ComparisonOperator,
  InquireBlackListsDto,
  InquireBlackListsQuery,
} from 'src/app/core/api/models';
import { BlackListsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';

@Component({
    selector: 'app-inquiry-black-list',
    templateUrl: './inquiry-black-list.component.html',
    imports: [BaseIndexModule],
    styles: [
        `
      fieldset {
        border: none !important;
      }
    `,
    ]
})
export class InquiryBlackListListComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region porperties
  @Input('model') selectedModel: InquireBlackListsQuery = {};

  items: Array<InquireBlackListsDto> = [];
  baseItems: Array<InquireBlackListsDto> = [];
  filteredItems: Array<InquireBlackListsDto> = [];

  isTableFiltered: boolean = false;

  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion
  constructor(protected currentService: BlackListsService) {
    super();
  }
  //#region init methods

  ngOnInit() {
    try {
      this.getVocabs();
      this.configTableColumns();
      this.initTablePagination();
      this.configPage();
      this.getTableData();
      this.pageConfig.title = 'common.blackListInquiry';
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: 'common.mobile',
        name: 'mobile',
        hasSearch: true,
        noSorting: true,
        customOperators: [ComparisonOperator.Contains],
      },
      {
        title: 'common.isBlackList',
        name: 'isBlackList',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: 'common.isExternalBlackList',
        name: 'isExternalBlackList',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
    ];
  }

  //#endregion

  //#region api

  getTableData() {
    this.unSubs();
    this.pageConfig.loading = true;
    this.currentService
      .blackListsInquireBlackLists({ body: this.selectedModel })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.baseItems = Object.assign([], result?.data);
        this.getPaginationData();
      });
  }

  //#endregion

  getPaginationData() {
    this.pageConfig.loading = true;

    this.paginationModel.totalPages = Math.ceil(
      (this.isTableFiltered
        ? this.filteredItems?.length
        : this.baseItems?.length) / this.paginationModel?.pageSize
    );
    this.paginationModel.totalCount = this.isTableFiltered
      ? this.filteredItems?.length
      : this.baseItems?.length;
    this.paginationModel.pageNumber = this.paginationModel.pageNumber
      ? this.paginationModel.pageNumber
      : 1;
    this.paginationModel.pageSize = this.paginationModel.pageSize
      ? this.paginationModel.pageSize
      : 30;
    this.paginationModel.hasNextPage =
      this.paginationModel.pageNumber < this.paginationModel.totalPages
        ? true
        : false;
    this.paginationModel.hasPreviousPage =
      this.paginationModel.pageNumber > 1 ? true : false;

    this.items = (
      this.isTableFiltered ? this.filteredItems : this.baseItems
    ).slice(
      (this.paginationModel.pageNumber - 1) * this.paginationModel.pageSize,
      this.paginationModel.pageNumber * this.paginationModel.pageSize
    );
    this.pageConfig.loading = false;
  }

  getComparisonObjects(model: ComparisonObjectsWithLogicalOperators[]) {
    this.comparisonObjects = model;
    this.paginationModel.pageNumber = 1;
    this.filterItems();
  }

  changePageNumber(pageNumber: number) {
    this.paginationModel.pageNumber = pageNumber;
    this.paginationModel.firstIndex =
      (pageNumber - 1) * this.paginationModel.pageSize + 1;
    this.getPaginationData();
  }

  changePageSize(pageSize: number) {
    this.paginationModel.pageSize = pageSize;
    this.paginationModel.pageNumber = 1;
    this.getPaginationData();
  }

  filterItems() {
    this.filteredItems = [];
    this.isTableFiltered = false;
    this.comparisonObjects.forEach((searchItem) => {
      searchItem.comparisonObjects.forEach((comparisonObjects) => {
        if (comparisonObjects.field == 'mobile') {
          this.isTableFiltered = true;
          this.filteredItems = [...this.baseItems].filter((item) =>
            (item[comparisonObjects.field] as string).includes(
              comparisonObjects.value
            )
          );
        }
        if (comparisonObjects.field == 'isBlackList') {
          this.isTableFiltered = true;
          this.filteredItems = [...this.baseItems].filter(
            (item) =>
              item[comparisonObjects.field] ==
              JSON.parse(comparisonObjects.value)
          );
        }
        if (comparisonObjects.field == 'isExternalBlackList') {
          this.isTableFiltered = true;
          this.filteredItems = [...this.baseItems].filter(
            (item) =>
              item[comparisonObjects.field] ==
              JSON.parse(comparisonObjects.value)
          );
        }
      });
    });

    this.paginationModel.pageNumber = 1;
    this.getPaginationData();
  }

  onClose() {
    this.output_closePage.emit(true);
  }

  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }
}
